import styled from "styled-components";
import { colors } from "ui-components";

const NavigationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.5rem;
  overflow: hidden;
  background-color: ${colors.whiteGrey};
  border-top: 1px solid ${colors.mediumGrey};
  border-radius: 0 0 5px 5px;

  button:not(:first-of-type) {
    margin-left: 1.25rem;
  }
`;

export { NavigationWrapper };



// WEBPACK FOOTER //
// ./src/common/styled/navigation.js